import { render } from "./leave-settings-modal.vue?vue&type=template&id=74b42de0"
import script from "./leave-settings-modal.vue?vue&type=script&lang=js"
export * from "./leave-settings-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__